'use strict';

import * as util from '../util/Common.js';
import * as domUtil from '../util/Dom.js';

const VALID_TAG_MAP = {
  'a': true,
  'b': true,
  'br': true,
  'i': true,
  'img': true,
  'p': true,
  'small': true,
  'span': true,
  'sub': true,
  'sup': true
};

function expandXml(baseNode, node){
  const l = node.childNodes.length;
  for (let i = 0; i < l; i++) {
    const child = node.childNodes[i];
    if (child.nodeType == Node.ELEMENT_NODE) {
      const tn = child.tagName.toLowerCase();
      if (VALID_TAG_MAP[tn]) {
        const cpChild = domUtil.createElement(tn);
        const href = child.getAttribute('href');
        if (href) {
          const trimHref = href.trim();
          if (trimHref.indexOf('http://') == 0 || trimHref.indexOf('https://') == 0) {
            domUtil.setAttr(cpChild, 'href', href);
          }
        }
        baseNode.appendChild(cpChild);
        expandXml(cpChild, child);
      }
    } else if (child.nodeType == Node.TEXT_NODE) {
      baseNode.appendChild(domUtil.text(child.textContent));
    }
  }
};
export function weakDomParse(text){
  if (!text) {
    return;
  } else if (window.DOMParser) {
    let xmlDoc;
    try {
      const parser = new DOMParser();
      xmlDoc = parser.parseFromString('<root>' + text + '</root>', "text/xml");
    } catch (ex) {
    }
    if (!xmlDoc || !xmlDoc.documentElement || xmlDoc.getElementsByTagName("parsererror").length) {
      return domUtil.text(text);
    }
    const valueContainer = domUtil.createElement('div');
    expandXml(valueContainer, xmlDoc.documentElement);
    return valueContainer;
  }
  return domUtil.text(text);
};
